import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
import auth from "./auth";
import env from "./env";

export default class CompaniesService {
  constructor($http, $localStorage, $state, SecurityService, AuthService, EnvService) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$security = SecurityService;
    this.$auth = AuthService;
    this.$env = EnvService;
  }

  eventsForEventsPage(companyId, offsetParam, maxParam, page, sort, order, isCompleted, isCancelled, dates) {
    if (this.$security.isUndefinedOrNull(sort)) {
      sort = "lastUpdated";
    }
    if (this.$security.isUndefinedOrNull(order)) {
      order = "desc";
    }

    let url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/companies/" +
      companyId +
      "/listEvents?sort=" +
      sort +
      "&order=" +
      order +
      "&max=" +
      maxParam +
      "&offset=" +
      offsetParam +
      "&isCompleted=" +
      isCompleted +
      "&isCancelled=" +
      isCancelled;

    if (_.isEmpty(dates) === false) {
      url = url + "&startTime=" + dates.start + "&endTime=" + dates.end;
    }

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: {},
    };

    return this.$http(req);
  }

  getApplicationErrors() {
    let url = this.$env.getAPIEndPoint() + "jbl/v1/application-errors/list-all";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },

      data: {},
    };

    return this.$http(req);
  }

  getEventPoolData(data) {
    let url = this.$env.getElasticSearchEventsAPIEndPoint();

    url =
      url +
      "ondemand/events?companyId=" +
      this.$localStorage.logged_user.company.id +
      "&eventPoolId=" +
      data.eventPoolId +
      "&offset=" +
      data.offset +
      "&direction=" +
      data.direction +
      "&sort=" +
      data.sort +
      "&max=" +
      data.max;

    let req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };

    return this.$http(req);
  }

  getJobs(data) {
    let url = this.$env.getAPIEndPoint();

    if (!data.offset) {
      data.offset = 0;
    }

    if (!data.max) {
      data.max = 10;
    }

    if (!data.sort) {
      data.sort = "startTime";
    }

    if (!data.order) {
      data.order = "asc";
    }

    if (!data.list) {
      data.list = "published";
    }

    if (_.isEmpty(data.dates) === false) {
      //do something
    }

    if (this.$localStorage.logged_user.company.isVerified === null || this.$localStorage.logged_user.company.isVerified === false) {
      url = url + "jbl/v1/companies/" + data.companyId + "/listEvents?sort=startTime&order=asc&max=10&offset=0&isCompleted=null&isCancelled=null";
    } else {
      if (data.multiSearch) {
        url =
          url + "jbl/v1/companies/" + data.companyId + "/listEvents?max=" + data.max + "&offset=" + data.offset + "&multiSearch=" + data.multiSearch;
      } else {
        url =
          url +
          "jbl/v1/companies/" +
          data.companyId +
          "/listEvents?sort=" +
          data.sort +
          "&order=" +
          data.order +
          "&max=" +
          data.max +
          "&offset=" +
          data.offset;
      }

      if (data.completedStatus === true) {
        url = url + "&isCompleted=true";
      }

      if (data.cancelledStatus === true) {
        url = url + "&isCancelled=true";
      } else if (data.cancelledStatus === false) {
        url = url + "&isCancelled=false";
      }

      if (data.isDraftStatus === true) {
        url = url + "&isCancelled=false&isDraft=true";
      }

      if (data.completedStatus !== true && data.cancelledStatus !== true && data.isDraftStatus !== true) {
        url = url + "&isCompleted=false&isCancelled=false&isDraft=false";
      }
    }

    let req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };

    return this.$http(req);
    /*
        let url = this.$env.getElasticSearchEventsAPIEndPoint();

        if (!data.offset) {
            data.offset = 0;
        }

        if (!data.max) {
            data.max = 10;
        }

        if (!data.sort) {
            data.sort = "startTime";
        }

        if (!data.order) {
            data.order = "asc";
        }

        if (!data.list) {
            data.list = "published";
        }

        if (_.isEmpty(data.dates) === false) {
            //do something
        }

        if (this.$localStorage.logged_user.company.isVerified === null || this.$localStorage.logged_user.company.isVerified === false) {

            url = url + "ondemand/events?sort=startTime&direction=desc&limit=10&offset=0&isCompleted=null&isCancelled=null";

        } else {

            if (data.multiSearch) {
                url = url + "ondemand/events?max=" + data.max + "&offset=" + data.offset + "&multiSearch=" + data.multiSearch;
            } else {
                url = url + "ondemand/events?sort=" + data.sort + "&direction=" + data.order + "&limit=" + data.max + "&offset=" + data.offset;
            }

            if (data.completedStatus === true) {
                url = url + "&isCompleted=true";
            }

            if (data.cancelledStatus === true) {
                url = url + "&isCancelled=true";
            } else if (data.cancelledStatus === false) {
                url = url + "&isCancelled=false";
            }

            if (data.isDraftStatus === true) {
                url = url + "&isCancelled=false&isDraft=true";
            }

            if (data.completedStatus !== true && data.cancelledStatus !== true && data.isDraftStatus !== true) {
                url = url + "&isCompleted=false&isCancelled=false&isDraft=false";
            }

        }

        url = url + "&companyId=" + this.$localStorage.logged_user.company.id;

        let req = {
            method: "GET",
            url: url,
            headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
            data: {},
        };

        return this.$http(req);
         */
  }

  getTeamsUltraTrim() {
    var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$auth.getUserData().company.id + "/circles?format=json&fields=id,name";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },

      data: {},
    };
    return this.$http(req);
  }

  getTeamsTrim() {
    let url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/companies/" +
      this.$auth.getUserData().company.id +
      "/listCircles?format=json&numberOfUsers=6&max=50&fields=id,name,numberOfUsers,users.id,users.lastName,users.firstName,users.filePROFILE_IMAGE1IMG_75x75";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },

      data: {},
    };
    return this.$http(req);
  }

  getPendingInvitations() {
    var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$auth.getUserData().company.id + "/companyUsers";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },

      data: {},
    };

    return this.$http(req);
  }

  getTeams() {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/companies/" +
      this.$auth.getUserData().company.id +
      "/circles?format=json&conf=web&&numberOfUsers=6&verbosity=3&fields=id,name,users";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },

      data: {},
    };

    return this.$http(req);
  }

  getTeamsSimple(totalNumberOfTeams) {
    if (!totalNumberOfTeams) {
      totalNumberOfTeams = 100;
    }
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/companies/" +
      this.$auth.getUserData().company.id +
      "/circles?format=json&conf=web&fields=id,name&verbosity=1&max=" +
      totalNumberOfTeams;
    var req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };
    return this.$http(req);
  }

  paginateThroughTeams(companyId, offsetParam, maxParam, sort, order) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/companies/" +
      companyId +
      "/listCircles?format=json&offset=" +
      offsetParam +
      "&max=" +
      maxParam +
      "&sort=" +
      sort +
      "&order=" +
      order +
      "&conf=web&numberOfUsers=6&fields=id,name,numberOfUsers,users.id,users.lastName,users.firstName,users.filePROFILE_IMAGE1IMG_75x75";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }

  fileTypesReq() {
    var url = this.$env.getAPIEndPoint() + "jbl/v1/file-types?conf=web&format=json&max=30";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }

  getTeamsOnEventEditPage(maxCount, offset = 0) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/companies/" +
      this.$auth.getUserData().company.id +
      "/circles?format=json&conf=web&max=" +
      maxCount.toString() +
      "&offset=" +
      offset.toString();
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }

  getDirectPaymentReceipts(maxCount, fid, offset = 0) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/companies/" +
      this.$auth.getUserData().company.id +
      "/files?format=json&conf=web&type=" +
      fid.toString() +
      "&max=" +
      maxCount.toString() +
      "&offset=" +
      offset.toString() +
      "&sort=dateCreated&order=desc";
    var reqDirectPaymentReceipts = {
      method: "GET",
      url: url,
      // url: "/app/vendor/api/get_payment_receipts.json",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: {},
    };
    return this.$http(reqDirectPaymentReceipts);
  }

  cancelPendingInvitation(t) {
    ///register/invite-user/cancel   and pass 'token' (invitation token) as param in the request json
    let data = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "register/invite-user/cancel",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {
        token: t
      }
    };

    return this.$http(data);
  }

  updateCloudWithNewUser(arr, email) {
    var _this = this;

    var updateCloud = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "/add-to-circle?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {
        users: email,
        circle: arr,
      },
    };

    return _this.$http(updateCloud);
  }

  saveCompanyProfileInformationNew(payload) {
    const req = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$auth.getUserData().id + "/updateMinimalFields",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: payload,
    };

    return this.$http(req);
  }

  saveCompanyProfileInformation(data) {
    const req = {
      method: "PUT",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        this.$auth.getUserData().id +
        "?format=json&fields=company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.description,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.city,company.mainContactInfo.state,company.mainContactInfo.zipCode",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: {
        company: {
          description: data.company_bio,
          name: data.company_name,
          legalCompanyName: data.legal_company_name,
          ein: data.ein,
          numberOfLocations: data.number_of_locations,
          mainContactInfo: {
            phoneMobile: data.company_phone,
            streetLine1: data.company_street_address,
            city: data.company_city,
            state: data.company_state,
            zipCode: data.company_zip_code,
          },
        },
      },
    };

    return this.$http(req);
  }

  updateUser(data) {
    var _this = this;
    var prop = data.prop;
    var payload = {};

    var req = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
    };

    switch (prop) {
      case 1:
        req.data = {firstName: data.value};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=firstName";
        break;
      case 2:
        req.data = {lastName: data.value};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=lastName";
        break;
      case 3:
        req.data = {homeContactInfo: {phoneMobile: data.value}};
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.phoneMobile";
        break;
      case 4:
        req.data = {homeContactInfo: {streetLine1: data.value}};
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.streetLine1";
        break;
      case 5:
        req.data = {homeContactInfo: {city: data.value}};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.city";
        break;
      case 6:
        req.data = {homeContactInfo: {state: data.value}};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.state";
        break;
      case 7:
        req.data = {homeContactInfo: {zipCode: data.value}};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.zipCode";
        break;
      case 8:
        req.data = {company: {name: data.value}};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=name";
        break;
      case 9:
        req.data = {
          company: {mainContactInfo: {firstName: data.value}},
        };
        req.url =
          _this.$env.getAPIEndPoint() +
          "jbl/v1/users/" +
          _this.$localStorage.logged_user.id +
          "?format=json&fields=company.mainContactInfo.firstName";
        break;
      case 10:
        req.data = {
          company: {mainContactInfo: {lastName: data.value}},
        };
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.lastName";
        break;
      case 11:
        req.data = {
          company: {mainContactInfo: {phoneMobile: data.value}},
        };
        req.url =
          _this.$env.getAPIEndPoint() +
          "jbl/v1/users/" +
          _this.$localStorage.logged_user.id +
          "?format=json&fields=company.mainContactInfo.phoneMobile";
        break;
      case 12:
        req.data = {
          company: {mainContactInfo: {streetLine1: data.value}},
        };
        req.url =
          _this.$env.getAPIEndPoint() +
          "jbl/v1/users/" +
          _this.$localStorage.logged_user.id +
          "?format=json&fields=company.mainContactInfo.streetLine1";
        break;
      case 13:
        req.data = {
          company: {mainContactInfo: {city: data.value}},
        };
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.city";
        break;
      case 14:
        req.data = {
          company: {mainContactInfo: {state: data.value}},
        };
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.state";
        break;
      case 15:
        req.data = {
          company: {mainContactInfo: {zipCode: data.value}},
        };
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.zipCode";
        break;
    }

    return _this.$http(req);
  }

  getSettings() {
    var _this = this;

    var req = {
      method: "GET",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/validate?format=json&fields=acceptedPrivacyPolicy,company.autoPost,company.autoAccept,company.autoManage,emailChatNotificationOn,brands,smsChatNotificationOn,company.industryType.id,company.industryType.name,company.postingTypesAllowed,company.payByInvoice,company.invoiceMarkup",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  updateCompanyBillingEmail(data) {
    var _this = this;

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/save-customer?format=json&conf=web&fields=id",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },

      data,
    };

    return _this.$http(req);
  }

  updateNotifications(data) {
    var _this = this;

    var req = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?conf=web&format=json&fields=id",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },

      data,
    };

    return _this.$http(req);
  }

  updateCloudWithNewUser(arr, email) {
    var _this = this;

    var updateCloud = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "/add-to-circle?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {
        users: email,
        circle: arr,
      },
    };

    return _this.$http(updateCloud);
  }

  updateUser(data) {
    var _this = this;

    var prop = data.prop;
    var payload = {};

    var req = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
    };

    switch (prop) {
      case 1:
        req.data = {firstName: data.value};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=firstName";
        break;
      case 2:
        req.data = {lastName: data.value};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=lastName";
        break;
      case 3:
        req.data = {homeContactInfo: {phoneMobile: data.value}};
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.phoneMobile";
        break;
      case 4:
        req.data = {homeContactInfo: {streetLine1: data.value}};
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.streetLine1";
        break;
      case 5:
        req.data = {homeContactInfo: {city: data.value}};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.city";
        break;
      case 6:
        req.data = {homeContactInfo: {state: data.value}};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.state";
        break;
      case 7:
        req.data = {homeContactInfo: {zipCode: data.value}};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.zipCode";
        break;
      case 8:
        req.data = {company: {name: data.value}};
        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=name";
        break;
      case 9:
        req.data = {company: {mainContactInfo: {firstName: data.value}}};
        req.url =
          _this.$env.getAPIEndPoint() +
          "jbl/v1/users/" +
          _this.$localStorage.logged_user.id +
          "?format=json&fields=company.mainContactInfo.firstName";
        break;
      case 10:
        req.data = {company: {mainContactInfo: {lastName: data.value}}};
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.lastName";
        break;
      case 11:
        req.data = {company: {mainContactInfo: {phoneMobile: data.value}}};
        req.url =
          _this.$env.getAPIEndPoint() +
          "jbl/v1/users/" +
          _this.$localStorage.logged_user.id +
          "?format=json&fields=company.mainContactInfo.phoneMobile";
        break;
      case 12:
        req.data = {company: {mainContactInfo: {streetLine1: data.value}}};
        req.url =
          _this.$env.getAPIEndPoint() +
          "jbl/v1/users/" +
          _this.$localStorage.logged_user.id +
          "?format=json&fields=company.mainContactInfo.streetLine1";
        break;
      case 13:
        req.data = {company: {mainContactInfo: {city: data.value}}};
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.city";
        break;
      case 14:
        req.data = {company: {mainContactInfo: {state: data.value}}};
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.state";
        break;
      case 15:
        req.data = {company: {mainContactInfo: {zipCode: data.value}}};
        req.url =
          _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.zipCode";
        break;
    }

    return _this.$http(req);
  }

  getFcaKey() {
    var _this = this;

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/fca-session",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken(),
      },
    };

    return _this.$http(req);
  }

  getIntentKey(payload) {
    var _this = this;

    console.log("getIntentKey");
    console.dir(payload);

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/setup-intent-session",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: payload,
    };

    return _this.$http(req);
  }

  updateIntentKey(payload) {
    var _this = this;

    console.log("updateIntentKey");
    console.dir(payload);

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/update-intent",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: payload,
    };

    return _this.$http(req);
  }

  updateIntentWithMicroDeposits(parsedAmount1, parsedAmount2, stripeId, setupId) {
    var _this = this;

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/update-intent-verify-microdeposit",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: {
        paymentMethodId: stripeId,
        setupId: setupId,
        amount1: parsedAmount1,
        amount2: parsedAmount2,
      },
    };

    return _this.$http(req);
  }

  loadUsers() {
    var _this = this;

    var req = {
      method: "GET",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/companies/" +
        _this.$localStorage.logged_user.company.id +
        "/users?format=json&conf=web&fields=id,dateCreated,firstName,lastName,homeContactInfo.phoneMobile,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine1,homeContactInfo.state,homeContactInfo.city,homeContactInfo.zipCode,emailChatNotificationOn,smsChatNotificationOn,username,email,authorities",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  getSettings() {
    var _this = this;

    var req = {
      method: "GET",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/validate?format=json&fields=acceptedPrivacyPolicy,company.autoPost,company.autoAccept,company.autoManage,emailChatNotificationOn,brands,smsChatNotificationOn,company.industryType.id,company.industryType.name,company.postingTypesAllowed,company.payByInvoice,company.sendInvoice,company.enableSubscription,company.invoiceMarkup",
      headers: {Authorization: "Bearer " + _this.$localStorage.logged_user.access_token},
      data: {},
    };

    return _this.$http(req);
  }

  updateNotifications(data) {
    var _this = this;

    var req = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?conf=web&format=json&fields=id",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },

      data,
    };

    return _this.$http(req);
  }

  updateInvoiceSettings(company) {
    var _this = this;

    //let data = {};

    console.log("companiesService: updateInvoiceSettings");
    console.dir(company);

    /*
        if (d.enableSubscription !== null && !angular.isUndefined(d.enableSubscription)) {
            console.log("here 1");
            data = {company: {enableSubscription: d.enableSubscription}};
        } else if (d.payByInvoice !== null && !angular.isUndefined(d.payByInvoice)) {
            console.log("here 2");
            data = {company: {payByInvoice: d.payByInvoice, invoiceMarkup: d.invoiceMarkup}};
        } else if (d.sendInvoice !== null && !angular.isUndefined(d.sendInvoice)) {
            console.log("here 3");
            data = {company: {sendInvoice: d.sendInvoice}};
        }
        */

    var req = {
      method: "PUT",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        _this.$localStorage.logged_user.id +
        "?conf=web&format=json&fields=id,company.payByInvoice,company.invoiceMarkup,company.sendInvoice,company.enableSubscription",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {
        company,
      },
    };

    return _this.$http(req);
  }

  updateCompanyAutoManage(payload) {
    var _this = this;

    var req = {
      method: "PUT",
      url:
        this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "?conf=web&format=json&fields=id,autoManage",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },

      data: payload,
    };

    return _this.$http(req);
  }

  updateCompanyAutoAccept(payload) {
    var _this = this;

    var req = {
      method: "PUT",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/companies/" +
        _this.$localStorage.logged_user.company.id +
        "?conf=web&format=json&fields=id,autoAccept,autoAcceptLimitTimeMark",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },

      data: payload,
    };

    return _this.$http(req);
  }

  update_post_type(data) {
    var _this = this;

    console.log("update_post_type");
    console.dir(data);

    var req = {
      method: "PUT",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/companies/" +
        _this.$localStorage.logged_user.company.id +
        "?conf=web&format=json&fields=id,postingTypesAllowed",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },

      data: {postingTypesAllowed: data},
    };

    return _this.$http(req);
  }

  storePreferredPostType(type) {
    var _this = this;

    var req = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "?conf=web&format=json&fields=id",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },

      data: {payPerConnect: type},
    };

    return _this.$http(req);
  }

  chargeForPost(data, invoice) {
    var _this = this;

    var account = _this.$env.EnvironmentConfig.jobbleAccounting;
    var req = {};

    if (invoice === true) {
      req.transfers = [{recipient: account, amount: data.amount, note: data.note}];
    } else {
      req.card = data.token;
      req.transfers = [{recipient: account, amount: data.amount, note: data.note}];
    }

    var reqPayJobbler = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: req,
    };

    return _this.$http(reqPayJobbler);
  }

  getCompanyUsers() {
    var _this = this;

    var req = {
      method: "GET",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/companies/" +
        _this.$localStorage.logged_user.company.id +
        "/users?format=json&max=30&fields=id,firstName,lastName,homeContactInfo.phoneMobile,email",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  makePayment(payload, user) {
    var _this = this;

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: payload,
    };

    return _this.$http(req);
  }

  loadJobblersFromTeam(id, query) {
    var _this = this;

    let url =
      _this.$env.getAPIEndPoint() +
      "jbl/v1/circles/" +
      id +
      "/users?format=json&fields=id,isVerified,firstName,lastName,paymentInfos.id,paymentInfos.last4,lastName,email,ssn,dateBirth,homeContactInfo.city,homeContactInfo.state,homeContactInfo.streetLine1,homeContactInfo.phoneMobile,bio,filePROFILE_IMAGE1IMG_75x75&sort=firstName&order=asc&max=" +
      query.max +
      "&offset=" +
      query.offset;

    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };

    return _this.$http(req);
  }

  getTeamDetails(id) {
    var _this = this;

    let url = _this.$env.getAPIEndPoint() + "jbl/v1/circles/" + id + "?format=json&fields=id,name";
    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };

    return _this.$http(req);
  }

  bulkPostJobs(data) {
    var _this = this;

    let payload = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pools",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken(),
      },

      data,
    };

    return _this.$http(payload);
  }

  deleteUserFromTeam(data) {
    var _this = this;

    let req = {
      method: "POST",
      url:
        _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "/remove-from-circle?format=json&conf=web",
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken(), "Content-Type": "application/json"},
      data: {circle: data.circle, users: data.users},
    };
    return _this.$http(req);
  }

  getCharges() {
    var _this = this;

    let url = _this.$env.getAPIEndPoint() + "jbl/v1/charges/";

    let req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: {},
    };

    return this.$http(req);
  }

  addToDNHList(data) {
    var _this = this;

    let req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/dnh",
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken(), "Content-Type": "application/json"},
      data: {list: data},
    };

    return _this.$http(req);
  }

  getAvailableDNHList() {
    var _this = this;

    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + "jbl/v1/dnh/availableJobblers",
      headers: {Authorization: "Bearer " + _this.$localStorage.logged_user.access_token},
      data: {},
    };

    return _this.$http(req);
  }

  getDoNotHireList() {
    var _this = this;

    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + "jbl/v1/dnh",
      headers: {Authorization: "Bearer " + _this.$localStorage.logged_user.access_token},
      data: {},
    };

    return _this.$http(req);
  }

  removeDoNotHireList(data) {
    var _this = this;

    var req = {
      method: "DELETE",
      url: this.$env.getAPIEndPoint() + "jbl/v1/dnh",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: data,
    };

    return _this.$http(req);
  }

  getPendingInvoices(start, end) {
    var _this = this;

    let url = _this.$env.getAPIEndPoint() + "jbl/v1/payments/pending-invoice?period" + start + "&periodEnd=" + end;

    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };

    return _this.$http(req);
  }

  getInvoices(data) {
    var _this = this;

    let url =
      _this.$env.getAPIEndPoint() + "jbl/v1/invoices/list?offset=" + data.offset + "&max=" + data.max + "&sort=" + data.sort + "&order=" + data.order;

    if (data.search) {
      url = _this.$env.getAPIEndPoint() + "jbl/v1/invoices/list?download=true&offset=" + data.offset + "&max=" + data.max + "&search=" + data.search;
    }

    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };

    return _this.$http(req);
  }

  getBill(data) {
    var _this = this;

    let url =
      _this.$env.getAPIEndPoint() +
      "jbl/v1/invoices/" +
      data.billId +
      "/details?download=true&offset=" +
      data.offset +
      "&max=" +
      data.max +
      "&sort=" +
      data.sort +
      "&order=" +
      data.order;

    if (data.search) {
      url =
        _this.$env.getAPIEndPoint() +
        "jbl/v1/invoices/" +
        data.billId +
        "/details?offset=" +
        data.offset +
        "&max=" +
        data.max +
        "&search=" +
        data.search;
    }

    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };

    return _this.$http(req);
  }

  createInAppNotifications(data) {
    let alerts = [];

    try {
      data.forEach(function (alert, index) {
        if (index < 6) {
          let formattedAlert = {};

          formattedAlert.rawAlert = alert;
          formattedAlert.name = alert.applicantUser.firstName + " " + alert.applicantUser.lastName;
          formattedAlert.eventId = alert.event.id;
          if (alert.errorCode === 111) {
          } else {
            if (alert.errorCode === 101) {
              formattedAlert.message =
                "The jobbler " +
                formattedAlert.name +
                " (" +
                alert.applicantUser.email +
                ") is not a verified user. They were not hired for job " +
                formattedAlert.eventId +
                ".";
            } else if (alert.errorText.indexOf("Could not find a jobble") > -1 || alert.errorCode === 107) {
              formattedAlert.message =
                "There were not enough openings to hire " +
                formattedAlert.name +
                " (" +
                alert.applicantUser.email +
                ") for job " +
                formattedAlert.eventId +
                ".";
            } else if (alert.errorText.indexOf("is already booked for this time frame") > -1) {
              formattedAlert.message =
                formattedAlert.name +
                " (" +
                alert.applicantUser.email +
                ") was already scheduled to work a job. He was not hired for job " +
                formattedAlert.eventId +
                ".";
            } else if (alert.errorText.indexOf("has been suspended.") > -1 || alert.errorCode === 102) {
              formattedAlert.message =
                formattedAlert.name +
                " (" +
                alert.applicantUser.email +
                ") has been suspended from our platform. He was not hired for job " +
                formattedAlert.eventId +
                ".";
            } else if (alert.errorText.indexOf("specify the jobble") > -1 || alert.errorCode === 101) {
              formattedAlert.message =
                formattedAlert.name +
                " (" +
                alert.applicantUser.email +
                ") did not have a Jobble assigned. He was not hired for job " +
                formattedAlert.eventId +
                ".";
            } else if (alert.errorText.indexOf("Do Not Hire.") > -1 || alert.errorCode === 104) {
              formattedAlert.message =
                formattedAlert.name +
                " (" +
                alert.applicantUser.email +
                ") was on a Do Not Hire list. He was not hired for job " +
                formattedAlert.eventId +
                ".";
            } else if (alert.errorText.indexOf("No application") > -1 || alert.errorCode === 106) {
              formattedAlert.message =
                formattedAlert.name +
                " (" +
                alert.applicantUser.email +
                ") did not have an application. He was not hired for job " +
                formattedAlert.eventId +
                ".";
            } else if (alert.errorText.indexOf("Transactional") > -1 || alert.errorCode === 109) {
              formattedAlert.message =
                formattedAlert.name +
                " (" +
                alert.applicantUser.email +
                ") has a transactional error during the hiring process. He was not hired for job " +
                formattedAlert.eventId +
                ".";
            } else {
              formattedAlert.message =
                "There was an issue hiring " +
                formattedAlert.name +
                " (" +
                alert.applicantUser.email +
                ") He was not hired for the job " +
                formattedAlert.eventId +
                ". Please contact support.";
            }

            formattedAlert.dateCreated = new Date(alert.dateCreated);
            formattedAlert.dateCreatedFormatted = moment(formattedAlert.dateCreated).format("MM/DD/YY hh:mm:ss A");

            alerts.push(formattedAlert);
          }
        }
      });
    } catch (err) {
      console.log("error collecting alerts");
      console.dir(err);
    } finally {
      console.log("alerts");
      console.dir(alerts);

      return alerts;
    }
  }

  achknowledgeApplicationError(id) {
    var _this = this;

    let req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/application-errors/ack",
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken(), "Content-Type": "application/json"},
      data: {applicationErrorId: id},
    };

    return _this.$http(req);
  }

  getUserRoles() {
    let url = this.$env.getAPIEndPoint() + "jbl/v1/users/groups";

    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };

    return this.$http(req);
  }

  getAuth() {
    var _this = this;

    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=username,authorities",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  updateUserRoles(data) {
    var _this = this;

    var req = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + data.userId + "/groups",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },

      data: {group: {id: data.groupId}},
    };

    return _this.$http(req);
  }

  getNotificationPreferences() {
    var _this = this;

    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + "jbl/v1/userEmailPreferences",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  createOrUpdateNotificationPreferences(d) {
    var _this = this;

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/userEmailPreferences",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },

      data: d,
    };

    return _this.$http(req);
  }

  updateNotificationPreferences(d) {
    var _this = this;

    var req = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/userEmailPreferences",
      headers: {
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },

      data: d,
    };

    return _this.$http(req);
  }

}

CompaniesService.$inject = ["$http", "$localStorage", "$state", "security", "auth", "env"];



// WEBPACK FOOTER //
// ./client/app/services/companies.js